import { Col, Row, Space } from "antd";

import Background from "@components/background";
import { Contain } from "@components/layout";
import UtilHeader from "@components/header/Util";

interface FlagHeaderProps {
    className: string;
    title: string;
    description: string | null;
    thumbImage?: any;
    bgSrc: string;
    children?: any;
    style?: any;
    loading?: boolean;
}

const defaultProps: FlagHeaderProps = {
    className: "",
    title: "Title is required",
    description: null,
    loading: false,
    bgSrc: "https://via.placeholder.com/1000x250/E6EAED/CCCCCC/",
};

const FlagHeader = ({
    className,
    title,
    description,
    thumbImage,
    bgSrc,
    style,
    children,
    loading,
}: FlagHeaderProps) => {
    const css: any = ["covr-header"];

    css.push(className);

    return (
        <Background className={css.join(" ")} src={bgSrc}>
            <Contain>
                <UtilHeader />
                <Row justify="space-between" align="middle">
                    <Col className="details">
                        <Row align="middle">
                            <Space>
                                {thumbImage && <Col>{thumbImage}</Col>}
                                <Col className={loading ? "loading-text" : ""}>
                                    <h1>
                                        <span>{title}</span>
                                    </h1>
                                    <p>
                                        <span>{description}</span>
                                    </p>
                                </Col>
                            </Space>
                        </Row>
                    </Col>
                    <Col>{children}</Col>
                </Row>
            </Contain>
        </Background>
    );
};

FlagHeader.defaultProps = defaultProps;

export default FlagHeader;
